import PropTypes from 'prop-types';

import { Content, CustomizedRichText, DensitySection, SectionImageGalery } from './styles';
import { isDeltaEmpty } from '../../OC/PageBuilder/RichText';

const Sections = ({ sections = [] }) =>
  sections.map(section => {
    const { title, content, images = [] } = section;

    return (
      <DensitySection key={title}>
        {title && <h3>{title}</h3>}
        <Content>
          {!isDeltaEmpty(content) && <CustomizedRichText inline content={content} />}
          {images.length > 0 && (
            <SectionImageGalery withContent={!isDeltaEmpty(content)}>
              {images.map(({ image = {}, caption }, index) => (
                <li key={caption || `image-${index}`}>
                  {image.file && <img src={image.file} alt={image.alt || caption || `Image ${index + 1}`} />}
                  {caption && <p>{caption}</p>}
                </li>
              ))}
            </SectionImageGalery>
          )}
        </Content>
      </DensitySection>
    );
  });

Sections.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.shape({
        ops: PropTypes.arrayOf(
          PropTypes.shape({
            insert: PropTypes.string,
            // eslint-disable-next-line react/forbid-prop-types
            attributes: PropTypes.object,
          })
        ),
      }), // Assuming content is a Delta object
      images: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.shape({
            file: PropTypes.string,
            alt: PropTypes.string,
          }),
          caption: PropTypes.string,
        })
      ),
    })
  ),
};

export default Sections;
